import { ApiLoadingStatus } from "enum/api-loading-status.enum";
import { IShipmentProfile } from "models/shipmentProfile/shipmentProfile.model";

export const hasProfiles = (
  loadingStatus: ApiLoadingStatus,
  profiles: IShipmentProfile[]
) => {
  return loadingStatus === ApiLoadingStatus.SUCCESS && profiles.length > 0;
};
